import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Hi, I'm <span className="highlight">Paarth Ahuja</span>
          </h1>
          <h2 className="hero-subtitle">
            Software Engineer at Bloomberg
          </h2>
          <p className="hero-description">
          I’m the first-born son of immigrant parents, raised with a simple expectation: figure it out and deliver. I take pride in solving hard problems and holding myself to a high bar.            <br />
            <br />
            I will never use AI agents for outreach. All my outreach is done manually, with significant intent and purpose. 
          </p>
          <div className="hero-buttons">
            <a href="#contact" className="btn btn-primary">Get In Touch</a>
            <a href="#experience" className="btn btn-outline">View Experience</a>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-placeholder">
            <img 
              src="logos/paarth-dp.jpeg" 
              alt="Paarth Ahuja" 
              className="profile-image"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const fallback = target.nextElementSibling as HTMLElement;
                if (fallback) fallback.classList.remove('hidden');
              }}
            />
            <div className="avatar-placeholder hidden">
              <span>PA</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
